"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _select = require("@alicd/next/lib/select");

var _select2 = _interopRequireDefault(_select);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SelectReadOnly = require("./SelectReadOnly");

var _SelectReadOnly2 = _interopRequireDefault(_SelectReadOnly);

var _SelectMultipleWrapNew = require("./SelectMultipleWrapNew");

var _SelectMultipleWrapNew2 = _interopRequireDefault(_SelectMultipleWrapNew);

var _cruiFormItem = require("@alicd/crui-form-item");

var _cruiFormItem2 = _interopRequireDefault(_cruiFormItem);

var _localeProvider = require("@alicd/next/lib/locale-provider");

var _localeProvider2 = _interopRequireDefault(_localeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectInnerWithLocale = (0, _localeProvider2.default)(_SelectReadOnly2.default);
SelectInnerWithLocale.LOCALE = _select2.default.LOCALE;

var SelectWrap = (0, _SelectMultipleWrapNew2.default)(SelectInnerWithLocale);

var SelectField = function (_React$Component) {
  (0, _inherits3.default)(SelectField, _React$Component);

  function SelectField() {
    (0, _classCallCheck3.default)(this, SelectField);
    return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
  }

  (0, _createClass3.default)(SelectField, [{
    key: "render",
    value: function render() {
      /* eslint-disable */
      var _props = this.props,
          bind = _props.bind,
          style = _props.style,
          locale = _props.locale,
          inputStyle = _props.inputStyle,
          children = _props.children,
          init = _props.init,
          other = (0, _objectWithoutProperties3.default)(_props, ["bind", "style", "locale", "inputStyle", "children", "init"]);
      var labelCol = other.labelCol,
          wrapperCol = other.wrapperCol,
          mapping = other.mapping,
          className = other.className,
          otherInput = (0, _objectWithoutProperties3.default)(other, ["labelCol", "wrapperCol", "mapping", "className"]);
      /* eslint-enable */

      return _react2.default.createElement(
        _cruiFormItem2.default,
        (0, _extends3.default)({}, other, { style: style }),
        _react2.default.createElement(
          SelectWrap,
          (0, _extends3.default)({}, otherInput, {
            style: inputStyle,
            cancelSelectAllText: this.props.cancelSelectAllText || this.props.locale.cancelSelectAll,
            selectAllText: this.props.selectAllText || this.props.locale.selectAll,
            statText: this.props.statText || this.props.locale.selectCount
          }),
          children
        )
      );
    }
  }]);
  return SelectField;
}(_react2.default.Component);

var LocaleMyComponent = (0, _localeProvider2.default)(SelectField);

LocaleMyComponent.LOCALE = {
  'en-us': {
    selectAll: 'Select All',
    cancelSelectAll: 'Cancel',
    selectCount: function selectCount(n, total) {
      return n + " of " + total + " selected";
    }
  },
  'zh-cn': {
    selectAll: '全选',
    cancelSelectAll: '取消全选',
    selectCount: function selectCount(n, total) {
      return "\u5DF2\u9009\u62E9 " + n + "/" + total + " \u9879";
    }
  },
  'zh-tw': {
    selectAll: '全選',
    cancelSelectAll: '取消全選',
    selectCount: function selectCount(n, total) {
      return "\u5DF2\u9078\u53D6 " + n + "/" + total + " \u9879";
    }
  }
};

exports.default = LocaleMyComponent;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-select-field@0.0.22@@alicd/crui-select-field/lib/index.js
// module id = 663
// module chunks = 0